import { localDatabaseUrls } from "../backend/constants";
import { getJWTToken } from "../shared/fetchWrapper/fetchWrapper";
import { putAPI } from "../backend/commons";
import AlertManager from "../shared/Alert/Alert";

const resolveUserEmail = (tokenInfo = {}) => tokenInfo.username ?? tokenInfo.email ?? "";

const resolveBatchId = (row) => row?.batchId ?? row?.batch_id ?? row?.batchid ?? "";

const resolveParsedSku = (row) => row?.parsedSku ?? row?.parsed_sku ?? row?.napaSku ?? row?.napa_sku ?? "";

const resolveHqLine = (row) => row?.hqLine ?? row?.hq_line ?? "";

const buildPayload = (rows, approvedBy, approvedStatus) =>
  rows.map((row) => ({
    batchId: resolveBatchId(row),
    parsedSku: resolveParsedSku(row),
    hqLine: resolveHqLine(row),
    approved: approvedStatus,
    approvedBy,
  }));

export const approveLandedFlaggedItems = async (rows = [], approvedStatus = "ReApproved") => {
  if (!Array.isArray(rows) || !rows.length) {
    return null;
  }

  const tokenInfo = await getJWTToken();
  if (!tokenInfo) {
    window.location.href = "/";
    return null;
  }

  const apiUrl = `${localDatabaseUrls.baseURL}${localDatabaseUrls.serviceURL.approveFlaggedItems}`;
  const payload = buildPayload(rows, resolveUserEmail(tokenInfo), approvedStatus);

  try {
    const response = await putAPI(apiUrl, tokenInfo, JSON.stringify(payload));

    if (response?.ok) {
      return response.json().catch(() => ({}));
    }

    const errorData = response?.json ? await response.json().catch(() => ({})) : {};
    throw new Error(errorData?.message || "Unable to approve flagged items.");
  } catch (error) {
    AlertManager.error(error?.message || "Unable to approve flagged items.", {
      contactSupport: false,
    });
    return null;
  }
};

export default approveLandedFlaggedItems;
